import { useEffect } from 'react'

import { pick } from '@eastcoal/common/utils/object'

import {
  $createNodeSelection,
  $getNodeByKey,
  $setSelection
} from '@eastcoal/editor/exports'
import { useEditor } from '@eastcoal/editor/hooks/useEditor'

import { useContractDesignerStore } from '../../Store/hooks/useStore'

export const useSelectTemplateVariableNode = () => {
  const { activedVariableNodeKey, setActivedVariableNodeKey } =
    useContractDesignerStore(state =>
      pick(state, ['activedVariableNodeKey', 'setActivedVariableNodeKey'])
    )
  const editor = useEditor()

  useEffect(() => {
    if (activedVariableNodeKey) {
      editor.update(() => {
        const selection = $createNodeSelection()
        selection.add(activedVariableNodeKey)
        $setSelection(selection)
      })
    }
  }, [activedVariableNodeKey, editor])

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      if (activedVariableNodeKey) {
        const isSelected = editorState.read(() => {
          const node = $getNodeByKey(activedVariableNodeKey)
          if (node === null) {
            return false
          }
          return node.isSelected()
        })
        if (!isSelected) {
          setActivedVariableNodeKey(undefined)
        }
      }
    })
  }, [activedVariableNodeKey, editor, setActivedVariableNodeKey])
}
